module.exports = __webpack_public_path__ + "f04d8b0d6164403444eae8f080f0d70b.css";